<template>
  <div>
    <quillEditor
        v-bind="$attrs"
        v-on="$listeners"
        :options="editorOption">
    </quillEditor>
  </div>
</template>

<script>
import { quillEditor } from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
// import 'quill/dist/i18n/zh-cn.js';
  export default {
    name: "EleInput",
    components: {
      quillEditor,
    },
    props: {
      required: {
        type: Boolean,
        default: false,
      },
      label: {
        type: String,
      },
      // // iview官方api没有该props，可代替 slot prepend 使用
      // prepend: {
      //   type: String,
      // },
      // // iview官方api没有该props，可代替 slot append 使用
      // append: {
      //   type: String,
      // },
      /**
       * 标签垂直对齐方式，通常是textarea输入框时标签需要置于输入框顶部
       * 可选：top、bottom、center（默认）
       */
      labelVerticalAlign: {
        type: String,
      },
    },
    computed: {
      // label垂直对齐方式，默认是center
      verticalAlign() {
        switch (this.labelVerticalAlign) {
          case "top":
            return "flex-start";
          case "bottom":
            return "flex-end";
          case "center":
            return "center";
          default:
            return this.type === "textarea" ? "flex-start" : "center";
        }
      },
    },
    data() {
      return {
        editorOption: {
          // quill的配置项
          theme: 'snow',  // or 'bubble'
          placeholder: 'Compose an epic...',
          modules: {
            // language: 'zh-cn',
            toolbar: {
              container: [
                [{ header: [1, 2, false] }],
                ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
                ['blockquote', 'code-block'],
                [{ list: 'ordered'}, { list: 'bullet' }],
                [{ script: 'sub'}, { script: 'super' }],      // superscript/subscript
                [{ indent: '-1'}, { indent: '+1' }],          // outdent/indent
                [{ direction: 'rtl' }],                         // text direction
                [{ size: ['small', false, 'large', 'huge'] }],  // custom dropdown/toolbar button values
                [{ header: [1, 2, 3, 4, 5, 6, false] }],
                [{ color: [] }, { background: [] }],          // dropdown with defaults from theme
                [{ font: ['AlibabaPB'] }],
                [{ align: [] }],
                ['clean'],                                         // remove formatting button
                ['link', 'image', 'video']                        // link and image, video
              ],
              handlers: {
                'image': function (value) {
                  if (value) {
                    // 自定义图片上传逻辑
                  }
                }
              }
            }
          }
        }
      };
    },
  };
</script>

<style lang="less" scoped>

</style>

<docs>
  ```vue
  <template>
    <ElementInput label="可以清除" placeholder="可以随意提示" clearable @clear="clearInput" v-model="input1"/>
    <ElementInput label="可以禁止" placeholder="可以随意提示" v-model="input1" disabled/>
    <ElementInput label="密码哦" required placeholder="密码" v-model="input2" show-password/>
    <ElementInput label="属性方式带入icon后面" required placeholder="icon" v-model="input2" suffix-icon="el-icon-date"/>
    <ElementInput label="属性方式带入icon前面" required placeholder="icon" v-model="input2" prefix-icon="el-icon-date"/>
    <ElementInput label="插槽方式带入icon前面" required placeholder="icon" v-model="input2" >
      <i slot="prefix" class="el-input__icon el-icon-search"></i>
    </ElementInput>
    <ElementInput label="插槽方式带入icon后面" required placeholder="icon" v-model="input2" >
      <i slot="suffix" class="el-input__icon el-icon-date"></i>
    </ElementInput>
    <ElementInput label="文本域" placeholder="可以随意提示" v-model="input2" type="textarea" :rows="12"/>
    <ElementInput label="文本域自适应" placeholder="可以随意提示" v-model="input2" type="textarea" autosize/>
    <ElementInput label="文本域定制" placeholder="可以随意提示" v-model="input2" type="textarea" :autosize="{ minRows: 2, maxRows: 4}"/>
    <ElementInput label="复合型输入框前" placeholder="可以随意提示" v-model="input2" >
      <template slot="prepend">Http://</template>
    </ElementInput>
    <ElementInput label="复合型输入框后" placeholder="可以随意提示" v-model="input2" >
      <template slot="append">.com</template>
    </ElementInput>
    <ElementInput label="复合型输入框自定义" placeholder="自定义" v-model="input2" >
      <!-- 下拉框 -->
      <el-select v-model="select" slot="prepend" placeholder="请选择">
        <el-option label="餐厅名" value="1"></el-option>
        <el-option label="订单号" value="2"></el-option>
        <el-option label="用户电话" value="3"></el-option>
      </el-select>
      <!-- 按钮 -->
      <el-button slot="append" icon="el-icon-search"></el-button>
    </ElementInput>
    <ElementInput label="inputWidth控制宽度。默认240px" placeholder="可以随意提示" v-model="input2" size="mini" :inputWidth="'long'" />
    <ElementInput label="show-word-limit" placeholder="可以随意提示" v-model="input2" type="textarea" :rows="2" maxlength="10" show-word-limit />
    <ElementInput label="resize" placeholder="可以随意提示" v-model="input2" type="textarea" :rows="2" maxlength="10" resize="none" />
    <ElementInput label="labelVerticalAlign位置" placeholder="可以随意提示" v-model="input2" type="textarea" :rows="12" :labelVerticalAlign="'bottom'" />
    <ElementInput label="maxlength" placeholder="可以随意提示" v-model="input2" maxlength="5" />
    <ElementInput label="minlength" placeholder="可以随意提示" v-model="input2" minlength="2" />
    <ElementInput label="change事件" placeholder="可以随意提示" v-model="input2" @change="changeInput" />
    <ElementInput label="input事件" placeholder="可以随意提示" v-model="input2" @input="inputInput" />
  </template>

  <script>
    export default {
      data() {
        return {
          input1: "111",
          input2: "",
          select: "",
        };
      },
      methods: {
        // input
        changeInput(v) {
          console.log(v);
        },
        inputInput(v) {
          console.log(v);
        },
        clearInput(v) {
          console.log(v,'已经清除');
        }
      },
    };
  </script>

  <style lang="less">
    // 给复合框自定义前的select的样式
    .el-select .el-input {
      width: 130px;
    }
    .input-with-select .el-input-group__prepend {
      background-color: #fff;
    }
  </style>
  ```
</docs>
